import {
  REQUEST_CONTENT_PAGE,
  REQUEST_CONTENT_PAGE_SUCCESS,
  REQUEST_CONTENT_PAGE_FAILED
} from "../actions/contentPage";
import { SET_PAGE } from "../actions/page";

export function contentPage(state = { data: [] }, action) {
  switch (action.type) {
    case REQUEST_CONTENT_PAGE:
      return state;
    case REQUEST_CONTENT_PAGE_SUCCESS:
      return {
        ...state,
        data: action.data,
        error: null
      };
    case REQUEST_CONTENT_PAGE_FAILED:
      return {
        ...state,
        data: [{ template: { id: "404_tmp", mode: "404" } }],
        error: action.error
      };
    case SET_PAGE:
      return {
        ...state,
        data: [{ template: { id: "loader_tmp", mode: "loader" } }],
        error: null
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/contentPage.js